import Vue from 'vue'
import Hotjar from 'vue-hotjar'
import { getEnvironment } from '@/utils/env-helper'
import { HOTJAR_SITE_ID } from '@/constants/config'

class HotjarService {
  static init() {
    Vue.use(Hotjar, {
      isProduction: getEnvironment() !== 'Development', // getEnvironment() === 'Live',
      id: HOTJAR_SITE_ID,
    })
  }

  static async setIdentity(user: any) {
    if (!Vue?.prototype?.$hj) {
      await new Promise(resolve => setTimeout(resolve, 1000))
    }

    if (!Vue?.prototype?.$hj) {
      // Here maybe Hotjar is disabled for non-live environments
      // console.error('Failed to set identity in Hotjar $hj not defined in Vue')
      return false
    }

    try {
      const payload = {
        name: user.name,
        email: user.email,
        businessType: user?.businessType.slug ?? 'unset',
        verified: !!user.verified,
        items_count: user.items_count,
        phone: user.phone,
        restaurant_name: user.restaurant_name,
      }
      Vue.prototype.$hj('identify', user.id, payload)
      console.log('hotjar set user attribute ', payload)
    } catch (e) {
      console.error(`Failed to set identity in Hotjar ${e.message}`, e)
    }
    return true
  }
}

export default HotjarService
